import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TreoCardModule} from '../../../../@treo/components/card';

import {UploadImageComponent} from './upload-image.component';
import {NgxImageCompressService} from 'ngx-image-compress';

@NgModule({
    declarations: [
        UploadImageComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatProgressSpinnerModule,
        TreoCardModule,
        MatTooltipModule
    ],
    providers: [
        NgxImageCompressService
    ],
    exports: [
        UploadImageComponent
    ]
})
export class UploadImageModule {
}
